import "../../Stylesheets/Main.css"

const NavDesktop = ({ ParallaxRef }) => {
    return (
        <nav className = "main-menu">
            <a href="#" className="main-menu-item" onClick={() => ParallaxRef.current.scrollTo(0)}>
                Start
            </a>
            <a href="#" className="main-menu-item" onClick={() => ParallaxRef.current.scrollTo(1)}>
                Service
            </a>
            <a href="#" className="main-menu-item" onClick={() => ParallaxRef.current.scrollTo(3.2)}>
                Produkte
            </a>
            <a href="#" className="main-menu-item" onClick={() => ParallaxRef.current.scrollTo(4.1)}>
                Kontakt
            </a>
        </nav>
    );
}

export default NavDesktop